<template>
    <base-form-control v-bind="formControlAttributes" is-textarea>
        <textarea v-on="listeners" v-bind="controlAttributes" :disabled="disabled" class="control" v-model="model"></textarea>
    </base-form-control>
</template>

<script>
import BaseFormControl from './BaseFormControl';
import BaseInput from './BaseInput';

export default {
    name       : 'form-textarea',
    components : { BaseFormControl },
    extends    : BaseInput
};
</script>
